(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'Stately-stately-concurrency-js-legacy', 'Reaktive-reaktive-js-legacy', 'klock-root-klock-js-legacy', 'kotlinx-serialization-kotlinx-serialization-core-js-legacy', 'kotlinx-serialization-kotlinx-serialization-protobuf-js-legacy', 'kotlinx-serialization-kotlinx-serialization-json-js-legacy', 'ktor-ktor-http-js-legacy', 'ktor-ktor-client-core-js-legacy', 'kotlinx-coroutines-core', 'ktor-ktor-http-cio-js-legacy'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('Stately-stately-concurrency-js-legacy'), require('Reaktive-reaktive-js-legacy'), require('klock-root-klock-js-legacy'), require('kotlinx-serialization-kotlinx-serialization-core-js-legacy'), require('kotlinx-serialization-kotlinx-serialization-protobuf-js-legacy'), require('kotlinx-serialization-kotlinx-serialization-json-js-legacy'), require('ktor-ktor-http-js-legacy'), require('ktor-ktor-client-core-js-legacy'), require('kotlinx-coroutines-core'), require('ktor-ktor-http-cio-js-legacy'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'moecoSdk-sdk'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'moecoSdk-sdk'.");
    }if (typeof this['Stately-stately-concurrency-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'moecoSdk-sdk'. Its dependency 'Stately-stately-concurrency-js-legacy' was not found. Please, check whether 'Stately-stately-concurrency-js-legacy' is loaded prior to 'moecoSdk-sdk'.");
    }if (typeof this['Reaktive-reaktive-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'moecoSdk-sdk'. Its dependency 'Reaktive-reaktive-js-legacy' was not found. Please, check whether 'Reaktive-reaktive-js-legacy' is loaded prior to 'moecoSdk-sdk'.");
    }if (typeof this['klock-root-klock-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'moecoSdk-sdk'. Its dependency 'klock-root-klock-js-legacy' was not found. Please, check whether 'klock-root-klock-js-legacy' is loaded prior to 'moecoSdk-sdk'.");
    }if (typeof this['kotlinx-serialization-kotlinx-serialization-core-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'moecoSdk-sdk'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core-js-legacy' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core-js-legacy' is loaded prior to 'moecoSdk-sdk'.");
    }if (typeof this['kotlinx-serialization-kotlinx-serialization-protobuf-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'moecoSdk-sdk'. Its dependency 'kotlinx-serialization-kotlinx-serialization-protobuf-js-legacy' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-protobuf-js-legacy' is loaded prior to 'moecoSdk-sdk'.");
    }if (typeof this['kotlinx-serialization-kotlinx-serialization-json-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'moecoSdk-sdk'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json-js-legacy' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json-js-legacy' is loaded prior to 'moecoSdk-sdk'.");
    }if (typeof this['ktor-ktor-http-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'moecoSdk-sdk'. Its dependency 'ktor-ktor-http-js-legacy' was not found. Please, check whether 'ktor-ktor-http-js-legacy' is loaded prior to 'moecoSdk-sdk'.");
    }if (typeof this['ktor-ktor-client-core-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'moecoSdk-sdk'. Its dependency 'ktor-ktor-client-core-js-legacy' was not found. Please, check whether 'ktor-ktor-client-core-js-legacy' is loaded prior to 'moecoSdk-sdk'.");
    }if (typeof this['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'moecoSdk-sdk'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'moecoSdk-sdk'.");
    }if (typeof this['ktor-ktor-http-cio-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'moecoSdk-sdk'. Its dependency 'ktor-ktor-http-cio-js-legacy' was not found. Please, check whether 'ktor-ktor-http-cio-js-legacy' is loaded prior to 'moecoSdk-sdk'.");
    }root['moecoSdk-sdk'] = factory(typeof this['moecoSdk-sdk'] === 'undefined' ? {} : this['moecoSdk-sdk'], kotlin, this['Stately-stately-concurrency-js-legacy'], this['Reaktive-reaktive-js-legacy'], this['klock-root-klock-js-legacy'], this['kotlinx-serialization-kotlinx-serialization-core-js-legacy'], this['kotlinx-serialization-kotlinx-serialization-protobuf-js-legacy'], this['kotlinx-serialization-kotlinx-serialization-json-js-legacy'], this['ktor-ktor-http-js-legacy'], this['ktor-ktor-client-core-js-legacy'], this['kotlinx-coroutines-core'], this['ktor-ktor-http-cio-js-legacy']);
  }
}(this, function (_, Kotlin, $module$Stately_stately_concurrency_js_legacy, $module$Reaktive_reaktive_js_legacy, $module$klock_root_klock_js_legacy, $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy, $module$kotlinx_serialization_kotlinx_serialization_protobuf_js_legacy, $module$kotlinx_serialization_kotlinx_serialization_json_js_legacy, $module$ktor_ktor_http_js_legacy, $module$ktor_ktor_client_core_js_legacy, $module$kotlinx_coroutines_core, $module$ktor_ktor_http_cio_js_legacy) {
  'use strict';
  var $$importsForInline$$ = _.$$importsForInline$$ || (_.$$importsForInline$$ = {});
  var AtomicReference = $module$Stately_stately_concurrency_js_legacy.co.touchlab.stately.concurrency.AtomicReference;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var ReadWriteProperty = Kotlin.kotlin.properties.ReadWriteProperty;
  var PropertyMetadata = Kotlin.PropertyMetadata;
  var takeLast = Kotlin.kotlin.collections.takeLast_mrm5p$;
  var Unit = Kotlin.kotlin.Unit;
  var observable = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.observable.observable_1em70n$;
  var single = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.single.single_akxzon$;
  var completable = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.completable.completable_lvdn7u$;
  var Kind_INTERFACE = Kotlin.Kind.INTERFACE;
  var throwCCE = Kotlin.throwCCE;
  var Disposable = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.disposable.Disposable;
  var take = Kotlin.kotlin.collections.take_mrm5p$;
  var joinToString = Kotlin.kotlin.collections.joinToString_fmv235$;
  var toString = Kotlin.kotlin.text.toString_dqglrj$;
  var padStart = Kotlin.kotlin.text.padStart_vrc1nu$;
  var collectionSizeOrDefault = Kotlin.kotlin.collections.collectionSizeOrDefault_ba2ldo$;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var toString_0 = Kotlin.toString;
  var takeUntil = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.observable.takeUntil_krhyhi$;
  var doOnAfterSuccess = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.single.doOnAfterSuccess_8ln6jy$;
  var flatMapObservable = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.single.flatMapObservable_rdj5ch$;
  var subscribe = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.observable.subscribe_fzbpy6$;
  var equals = Kotlin.equals;
  var subscribe_0 = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.completable.subscribe_f87uvb$;
  var plus = Kotlin.kotlin.collections.plus_lamh9t$;
  var toByte = Kotlin.kotlin.text.toByte_6ic1pp$;
  var IllegalStateException_init = Kotlin.kotlin.IllegalStateException_init_pdl1vj$;
  var L127 = Kotlin.Long.fromInt(127);
  var get_lastIndex = Kotlin.kotlin.collections.get_lastIndex_m7z4lg$;
  var Enum = Kotlin.kotlin.Enum;
  var throwISE = Kotlin.throwISE;
  var L1 = Kotlin.Long.ONE;
  var toByte_0 = Kotlin.toByte;
  var scheduler = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.scheduler;
  var observableTimer = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.observable.observableTimer_rg1l04$;
  var takeUntil_0 = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.observable.takeUntil_gsg2fm$;
  var filter = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.observable.filter_krhyhi$;
  var toList = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.observable.toList_6g6uxn$;
  var toList_0 = Kotlin.kotlin.collections.toList_7wnvza$;
  var map = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.single.map_atu93h$;
  var listOfNotNull = Kotlin.kotlin.collections.listOfNotNull_issdgt$;
  var plus_0 = Kotlin.kotlin.collections.plus_mydzjv$;
  var Collection = Kotlin.kotlin.collections.Collection;
  var mapCapacity = Kotlin.kotlin.collections.mapCapacity_za3lpa$;
  var coerceAtLeast = Kotlin.kotlin.ranges.coerceAtLeast_dqglrj$;
  var LinkedHashMap_init = Kotlin.kotlin.collections.LinkedHashMap_init_bwtc7$;
  var TimeSpan = $module$klock_root_klock_js_legacy.com.soywiz.klock.TimeSpan;
  var listOf = Kotlin.kotlin.collections.listOf_mh5how$;
  var emptyList = Kotlin.kotlin.collections.emptyList_287e2$;
  var firstOrNull = Kotlin.kotlin.collections.firstOrNull_2p1efm$;
  var singleOfError = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.single.singleOfError_lsqlk3$;
  var flatMap = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.single.flatMap_hwzf4f$;
  var zip = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.single.zip_77y6fp$;
  var notNull = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.single.notNull_lzwf6w$;
  var flatMapMaybe = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.single.flatMapMaybe_5lasv9$;
  var completableOfEmpty = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.completable.completableOfEmpty;
  var flatMapCompletable = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.maybe.flatMapCompletable_pt49ee$;
  var toList_1 = Kotlin.kotlin.collections.toList_us0mfu$;
  var DateTime = $module$klock_root_klock_js_legacy.com.soywiz.klock.DateTime;
  var completableFromFunction = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.completable.completableFromFunction_o14v8n$;
  var subscribeOn = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.completable.subscribeOn_tqcyfb$;
  var L3 = Kotlin.Long.fromInt(3);
  var L4 = Kotlin.Long.fromInt(4);
  var L6 = Kotlin.Long.fromInt(6);
  var PluginGeneratedSerialDescriptor = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.internal.PluginGeneratedSerialDescriptor;
  var UnknownFieldException = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.UnknownFieldException;
  var internal = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.internal;
  var GeneratedSerializer = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.internal.GeneratedSerializer;
  var MissingFieldException_init = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.MissingFieldException_init_61zpoe$;
  var NullableSerializer = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.internal.NullableSerializer;
  var ProtoBuf = $module$kotlinx_serialization_kotlinx_serialization_protobuf_js_legacy.kotlinx.serialization.protobuf.ProtoBuf;
  var Json = $module$kotlinx_serialization_kotlinx_serialization_json_js_legacy.kotlinx.serialization.json.Json;
  var getKClass = Kotlin.getKClass;
  var createKType = Kotlin.createKType;
  var serializer = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.serializer_ca95z9$;
  var KSerializer = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.KSerializer;
  var andThen = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.completable.andThen_jmqf3l$;
  var concat = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.completable.concat_ili6v5$;
  var flatMapCompletable_0 = $module$Reaktive_reaktive_js_legacy.com.badoo.reaktive.single.flatMapCompletable_9do6ve$;
  var URLProtocol = $module$ktor_ktor_http_js_legacy.io.ktor.http.URLProtocol;
  var webSocketSession = $module$ktor_ktor_client_core_js_legacy.io.ktor.client.features.websocket.webSocketSession_e8a0az$;
  var Throwable = Error;
  var COROUTINE_SUSPENDED = Kotlin.kotlin.coroutines.intrinsics.COROUTINE_SUSPENDED;
  var CoroutineImpl = Kotlin.kotlin.coroutines.CoroutineImpl;
  var launch = $module$kotlinx_coroutines_core.kotlinx.coroutines.launch_s496o7$;
  var WebSockets = $module$ktor_ktor_client_core_js_legacy.io.ktor.client.features.websocket.WebSockets;
  var HttpClient = $module$ktor_ktor_client_core_js_legacy.io.ktor.client.HttpClient_f0veat$;
  var send = $module$ktor_ktor_http_cio_js_legacy.io.ktor.http.cio.websocket.send_limcqc$;
  var close = $module$ktor_ktor_http_cio_js_legacy.io.ktor.http.cio.websocket.close_icv0wc$;
  BleConnectionState$BleConnectedState.prototype = Object.create(BleConnectionState.prototype);
  BleConnectionState$BleConnectedState.prototype.constructor = BleConnectionState$BleConnectedState;
  BleConnectionState$BleDisconnectedState.prototype = Object.create(BleConnectionState.prototype);
  BleConnectionState$BleDisconnectedState.prototype.constructor = BleConnectionState$BleDisconnectedState;
  Number_0.prototype = Object.create(Enum.prototype);
  Number_0.prototype.constructor = Number_0;
  LogLevel.prototype = Object.create(Enum.prototype);
  LogLevel.prototype.constructor = LogLevel;
  function Atomic(initial) {
    this.atomic_0 = new AtomicReference(initial);
  }
  Atomic.prototype.getValue_lrcp0p$ = function (thisRef, property) {
    return this.atomic_0.get();
  };
  Atomic.prototype.setValue_9rddgb$ = function (thisRef, property, value) {
    this.atomic_0.set_11rb$(value);
  };
  Atomic.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Atomic',
    interfaces: [ReadWriteProperty]
  };
  function ByteBuffer(bytes) {
    this.bytes_0 = bytes;
    this.currentPosition_miylcz$_0 = new Atomic(0);
  }
  var ByteBuffer$currentPosition_metadata = new PropertyMetadata('currentPosition');
  Object.defineProperty(ByteBuffer.prototype, 'currentPosition', {
    configurable: true,
    get: function () {
      return this.currentPosition_miylcz$_0.getValue_lrcp0p$(this, ByteBuffer$currentPosition_metadata);
    },
    set: function (currentPosition) {
      this.currentPosition_miylcz$_0.setValue_9rddgb$(this, ByteBuffer$currentPosition_metadata, currentPosition);
    }
  });
  ByteBuffer.prototype.get = function () {
    var $receiver = this.bytes_0[this.currentPosition];
    this.currentPosition = this.currentPosition + 1 | 0;
    return $receiver;
  };
  ByteBuffer.prototype.remainingBytes = function () {
    return takeLast(this.bytes_0, this.bytes_0.length - this.currentPosition | 0);
  };
  ByteBuffer.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'ByteBuffer',
    interfaces: []
  };
  function Disposable$ObjectLiteral(closure$onDispose) {
    this.closure$onDispose = closure$onDispose;
    this.isDisposed_y7vm1v$_0 = false;
  }
  Object.defineProperty(Disposable$ObjectLiteral.prototype, 'isDisposed', {configurable: true, get: function () {
    return this.isDisposed_y7vm1v$_0;
  }, set: function (isDisposed) {
    this.isDisposed_y7vm1v$_0 = isDisposed;
  }});
  Disposable$ObjectLiteral.prototype.dispose = function () {
    if (!this.isDisposed) {
      this.isDisposed = true;
      this.closure$onDispose();
    }};
  Disposable$ObjectLiteral.$metadata$ = {kind: Kind_CLASS, interfaces: [Disposable]};
  function moecoObservable$lambda(closure$observableEmitter) {
    return function (it) {
      closure$observableEmitter(new MoecoObservableEmitter(it));
      return Unit;
    };
  }
  function moecoObservable(observableEmitter) {
    return observable(moecoObservable$lambda(observableEmitter));
  }
  function moecoSingle$lambda(closure$singleEmitter) {
    return function (it) {
      closure$singleEmitter(new MoecoSingleEmitter(it));
      return Unit;
    };
  }
  function moecoSingle(singleEmitter) {
    return single(moecoSingle$lambda(singleEmitter));
  }
  function moecoCompletable$lambda(closure$completableEmitter) {
    return function (it) {
      closure$completableEmitter(new MoecoCompletableEmitter(it));
      return Unit;
    };
  }
  function moecoCompletable(completableEmitter) {
    return completable(moecoCompletable$lambda(completableEmitter));
  }
  function PlatformScanner() {
  }
  PlatformScanner.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'PlatformScanner',
    interfaces: []
  };
  function PlatformBleScanner(platformScanner) {
    this.platformScanner = platformScanner;
  }
  function PlatformBleScanner$scanDevices$lambda$lambda(this$PlatformBleScanner) {
    return function () {
      this$PlatformBleScanner.platformScanner.stopScan();
      return Unit;
    };
  }
  function PlatformBleScanner$scanDevices$lambda$lambda_0(closure$emitter) {
    return function (it) {
      var tmp$, tmp$_0;
      tmp$_0 = Kotlin.isType(tmp$ = it, BleDevice) ? tmp$ : throwCCE();
      closure$emitter.onNext(tmp$_0);
      return Unit;
    };
  }
  function PlatformBleScanner$scanDevices$lambda(this$PlatformBleScanner) {
    return function (emitter) {
      emitter.setCancellable(PlatformBleScanner$scanDevices$lambda$lambda(this$PlatformBleScanner));
      this$PlatformBleScanner.platformScanner.startScan_5ij4lk$(PlatformBleScanner$scanDevices$lambda$lambda_0(emitter));
      return Unit;
    };
  }
  PlatformBleScanner.prototype.scanDevices = function () {
    return moecoObservable(PlatformBleScanner$scanDevices$lambda(this));
  };
  PlatformBleScanner.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'PlatformBleScanner',
    interfaces: [BleScanner]
  };
  function MoecoObservableEmitter(emitter) {
    this.emitter_0 = emitter;
  }
  MoecoObservableEmitter.prototype.setCancellable = function (cancelable) {
    this.emitter_0.setDisposable_dbza2w$(new Disposable$ObjectLiteral(cancelable));
  };
  MoecoObservableEmitter.prototype.onNext = function (value) {
    this.emitter_0.onNext_11rb$(value);
  };
  MoecoObservableEmitter.prototype.onComplete = function () {
    this.emitter_0.onComplete();
  };
  MoecoObservableEmitter.prototype.onError = function (error) {
    this.emitter_0.onError_tcv7n7$(error);
  };
  MoecoObservableEmitter.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'MoecoObservableEmitter',
    interfaces: []
  };
  function MoecoSingleEmitter(emitter) {
    this.emitter_0 = emitter;
  }
  MoecoSingleEmitter.prototype.setCancelable = function (cancelable) {
    this.emitter_0.setDisposable_dbza2w$(new Disposable$ObjectLiteral(cancelable));
  };
  MoecoSingleEmitter.prototype.onSuccess = function (value) {
    this.emitter_0.onSuccess_11rb$(value);
  };
  MoecoSingleEmitter.prototype.onError = function (error) {
    this.emitter_0.onError_tcv7n7$(error);
  };
  MoecoSingleEmitter.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'MoecoSingleEmitter',
    interfaces: []
  };
  function MoecoCompletableEmitter(emitter) {
    this.emitter_0 = emitter;
  }
  MoecoCompletableEmitter.prototype.setCancelable = function (cancelable) {
    this.emitter_0.setDisposable_dbza2w$(new Disposable$ObjectLiteral(cancelable));
  };
  MoecoCompletableEmitter.prototype.onComplete = function () {
    this.emitter_0.onComplete();
  };
  MoecoCompletableEmitter.prototype.onError = function (error) {
    this.emitter_0.onError_tcv7n7$(error);
  };
  MoecoCompletableEmitter.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'MoecoCompletableEmitter',
    interfaces: []
  };
  function BleDevice() {
  }
  Object.defineProperty(BleDevice.prototype, 'uid', {
    configurable: true,
    get: function () {
      var tmp$, tmp$_0, tmp$_1, tmp$_2;
      var tmp$_3;
      if ((tmp$_1 = (tmp$_0 = (tmp$ = this.manufacturerData) != null ? tmp$.get_11rb$(1970) : null) != null ? take(tmp$_0, 6) : null) != null) {
        var destination = ArrayList_init(collectionSizeOrDefault(tmp$_1, 10));
        var tmp$_4;
        tmp$_4 = tmp$_1.iterator();
        while (tmp$_4.hasNext()) {
          var item = tmp$_4.next();
          destination.add_11rb$(toHex(item));
        }
        tmp$_3 = destination;
      } else
        tmp$_3 = null;
      return (tmp$_2 = tmp$_3) != null ? joinToString(tmp$_2, ':') : null;
    }
  });
  BleDevice.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'BleDevice',
    interfaces: []
  };
  function toHex($receiver) {
    return padStart(toString(255 & $receiver, 16), 2, 48);
  }
  function BleConnection() {
  }
  BleConnection.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'BleConnection',
    interfaces: []
  };
  function BleConnectionState() {
  }
  function BleConnectionState$BleConnectedState() {
    BleConnectionState$BleConnectedState_instance = this;
    BleConnectionState.call(this);
  }
  BleConnectionState$BleConnectedState.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'BleConnectedState',
    interfaces: [BleConnectionState]
  };
  var BleConnectionState$BleConnectedState_instance = null;
  function BleConnectionState$BleConnectedState_getInstance() {
    if (BleConnectionState$BleConnectedState_instance === null) {
      new BleConnectionState$BleConnectedState();
    }return BleConnectionState$BleConnectedState_instance;
  }
  function BleConnectionState$BleDisconnectedState() {
    BleConnectionState$BleDisconnectedState_instance = this;
    BleConnectionState.call(this);
  }
  BleConnectionState$BleDisconnectedState.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'BleDisconnectedState',
    interfaces: [BleConnectionState]
  };
  var BleConnectionState$BleDisconnectedState_instance = null;
  function BleConnectionState$BleDisconnectedState_getInstance() {
    if (BleConnectionState$BleDisconnectedState_instance === null) {
      new BleConnectionState$BleDisconnectedState();
    }return BleConnectionState$BleDisconnectedState_instance;
  }
  BleConnectionState.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'BleConnectionState',
    interfaces: []
  };
  function MoecoBleCharacteristic(characteristic, service) {
    if (service === void 0)
      service = MOECO_SERVICE_ID;
    this.characteristic = characteristic;
    this.service = service;
  }
  MoecoBleCharacteristic.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'MoecoBleCharacteristic',
    interfaces: []
  };
  MoecoBleCharacteristic.prototype.component1 = function () {
    return this.characteristic;
  };
  MoecoBleCharacteristic.prototype.component2 = function () {
    return this.service;
  };
  MoecoBleCharacteristic.prototype.copy_puj7f4$ = function (characteristic, service) {
    return new MoecoBleCharacteristic(characteristic === void 0 ? this.characteristic : characteristic, service === void 0 ? this.service : service);
  };
  MoecoBleCharacteristic.prototype.toString = function () {
    return 'MoecoBleCharacteristic(characteristic=' + Kotlin.toString(this.characteristic) + (', service=' + Kotlin.toString(this.service)) + ')';
  };
  MoecoBleCharacteristic.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.characteristic) | 0;
    result = result * 31 + Kotlin.hashCode(this.service) | 0;
    return result;
  };
  MoecoBleCharacteristic.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.characteristic, other.characteristic) && Kotlin.equals(this.service, other.service)))));
  };
  function BleConnectionHandler(logger, bleConnection) {
    this.logger_0 = logger;
    this.bleConnection_0 = bleConnection;
    this.expectedUnum_m7jjw7$_0 = new Atomic(Number$NUM0_getInstance());
    this.dnum_xlxl1s$_0 = new Atomic(Number$NUM0_getInstance());
    this.bytesToSave_h7sif5$_0 = new Atomic(new Int8Array([]));
    this.exception_vls4z1$_0 = new Atomic(null);
  }
  var BleConnectionHandler$expectedUnum_metadata = new PropertyMetadata('expectedUnum');
  Object.defineProperty(BleConnectionHandler.prototype, 'expectedUnum_0', {
    configurable: true,
    get: function () {
      return this.expectedUnum_m7jjw7$_0.getValue_lrcp0p$(this, BleConnectionHandler$expectedUnum_metadata);
    },
    set: function (expectedUnum) {
      this.expectedUnum_m7jjw7$_0.setValue_9rddgb$(this, BleConnectionHandler$expectedUnum_metadata, expectedUnum);
    }
  });
  var BleConnectionHandler$dnum_metadata = new PropertyMetadata('dnum');
  Object.defineProperty(BleConnectionHandler.prototype, 'dnum_0', {
    configurable: true,
    get: function () {
      return this.dnum_xlxl1s$_0.getValue_lrcp0p$(this, BleConnectionHandler$dnum_metadata);
    },
    set: function (dnum) {
      this.dnum_xlxl1s$_0.setValue_9rddgb$(this, BleConnectionHandler$dnum_metadata, dnum);
    }
  });
  var BleConnectionHandler$bytesToSave_metadata = new PropertyMetadata('bytesToSave');
  Object.defineProperty(BleConnectionHandler.prototype, 'bytesToSave_0', {
    configurable: true,
    get: function () {
      return this.bytesToSave_h7sif5$_0.getValue_lrcp0p$(this, BleConnectionHandler$bytesToSave_metadata);
    },
    set: function (bytesToSave) {
      this.bytesToSave_h7sif5$_0.setValue_9rddgb$(this, BleConnectionHandler$bytesToSave_metadata, bytesToSave);
    }
  });
  var BleConnectionHandler$exception_metadata = new PropertyMetadata('exception');
  Object.defineProperty(BleConnectionHandler.prototype, 'exception_0', {
    configurable: true,
    get: function () {
      return this.exception_vls4z1$_0.getValue_lrcp0p$(this, BleConnectionHandler$exception_metadata);
    },
    set: function (exception) {
      this.exception_vls4z1$_0.setValue_9rddgb$(this, BleConnectionHandler$exception_metadata, exception);
    }
  });
  BleConnectionHandler.prototype.scanMessage_0 = function (bleConnection, text) {
    return '[' + bleConnection.bleDevice.address + '] ' + text;
  };
  BleConnectionHandler.prototype.onDisconnected_sc8xzf$ = function (emitter) {
    var tmp$, tmp$_0;
    if (this.bytesToSave_0.length === 0) {
      this.logger_0.logInfo_puj7f4$(TAG, this.scanMessage_0(this.bleConnection_0, 'Disconnected with error = ' + toString_0(this.exception_0)));
      var tmp$_1;
      if ((tmp$ = this.exception_0) != null) {
        emitter.onError_tcv7n7$(tmp$);
        tmp$_1 = Unit;
      } else
        tmp$_1 = null;
      (tmp$_0 = tmp$_1) != null ? tmp$_0 : emitter.onSuccess_11rb$(null);
    } else {
      this.logger_0.logInfo_puj7f4$(TAG, this.scanMessage_0(this.bleConnection_0, 'Saving messages, bytes size = ' + this.bytesToSave_0.length));
      emitter.onSuccess_11rb$(this.bytesToSave_0);
    }
  };
  function BleConnectionHandler$handleConnection$lambda$lambda(it) {
    return Kotlin.isType(it, BleConnectionState$BleDisconnectedState);
  }
  function BleConnectionHandler$handleConnection$lambda$lambda$errorHandler$lambda(this$BleConnectionHandler, closure$additionalText) {
    return function (ex) {
      if (ex != null) {
        var tmp$;
        this$BleConnectionHandler.logger_0.logError_puj7f4$(TAG, closure$additionalText + ((tmp$ = ex.message) != null ? tmp$ : 'empty'));
      }this$BleConnectionHandler.exception_0 = ex;
      this$BleConnectionHandler.bleConnection_0.disconnect();
      return Unit;
    };
  }
  function BleConnectionHandler$handleConnection$lambda$lambda$errorHandler(this$BleConnectionHandler) {
    return function (additionalText) {
      return BleConnectionHandler$handleConnection$lambda$lambda$errorHandler$lambda(this$BleConnectionHandler, additionalText);
    };
  }
  function BleConnectionHandler$handleConnection$lambda$lambda$lambda$lambda(this$BleConnectionHandler) {
    return function () {
      this$BleConnectionHandler.logger_0.logInfo_puj7f4$(TAG, this$BleConnectionHandler.scanMessage_0(this$BleConnectionHandler.bleConnection_0, 'Notification setup'));
      return Unit;
    };
  }
  function BleConnectionHandler$handleConnection$lambda$lambda$lambda(this$BleConnectionHandler, closure$errorHandler) {
    return function (it) {
      this$BleConnectionHandler.sendCommand_0(this$BleConnectionHandler.bleConnection_0, this$BleConnectionHandler.generateMessage_0(START_COMMAND), closure$errorHandler('Error while sending start command: '), BleConnectionHandler$handleConnection$lambda$lambda$lambda$lambda(this$BleConnectionHandler));
      return Unit;
    };
  }
  function BleConnectionHandler$handleConnection$lambda$lambda$lambda_0(it) {
    return it;
  }
  function BleConnectionHandler$handleConnection$lambda$lambda$lambda_1(this$BleConnectionHandler, closure$errorHandler) {
    return function (it) {
      this$BleConnectionHandler.handleNewMessage_0(this$BleConnectionHandler.bleConnection_0, it, closure$errorHandler('Error while handling notification: '));
      return Unit;
    };
  }
  function BleConnectionHandler$handleConnection$lambda$lambda_0(this$BleConnectionHandler, closure$emitter) {
    return function (it) {
      var errorHandler = BleConnectionHandler$handleConnection$lambda$lambda$errorHandler(this$BleConnectionHandler);
      if (equals(it, BleConnectionState$BleConnectedState_getInstance()))
        subscribe(flatMapObservable(doOnAfterSuccess(this$BleConnectionHandler.bleConnection_0.setupNotifications(new MoecoBleCharacteristic(MOECO_CHARACTERISTIC_ID)), BleConnectionHandler$handleConnection$lambda$lambda$lambda(this$BleConnectionHandler, errorHandler)), BleConnectionHandler$handleConnection$lambda$lambda$lambda_0), void 0, void 0, errorHandler('Error while setup notifications: '), void 0, BleConnectionHandler$handleConnection$lambda$lambda$lambda_1(this$BleConnectionHandler, errorHandler));
      else if (Kotlin.isType(it, BleConnectionState$BleDisconnectedState))
        this$BleConnectionHandler.onDisconnected_sc8xzf$(closure$emitter);
      else
        Kotlin.noWhenBranchMatched();
      return Unit;
    };
  }
  function BleConnectionHandler$handleConnection$lambda(this$BleConnectionHandler) {
    return function (emitter) {
      subscribe(takeUntil(this$BleConnectionHandler.bleConnection_0.listenToState(), BleConnectionHandler$handleConnection$lambda$lambda), void 0, void 0, void 0, void 0, BleConnectionHandler$handleConnection$lambda$lambda_0(this$BleConnectionHandler, emitter));
      return Unit;
    };
  }
  BleConnectionHandler.prototype.handleConnection = function () {
    return single(BleConnectionHandler$handleConnection$lambda(this));
  };
  BleConnectionHandler.prototype.sendCommand_0 = function (bleConnection, byteArray, onError, onSuccess) {
    subscribe_0(bleConnection.writeCharacteristic(new MoecoBleCharacteristic(MOECO_CHARACTERISTIC_ID), byteArray), void 0, void 0, onError, onSuccess);
  };
  BleConnectionHandler.prototype.handleNewMessage_0 = function (bleConnection, message, onError) {
    var tmp$;
    var bytebuffer = new ByteBuffer(message);
    var messageProperties = new MessageProperties(getVarLong(bytebuffer));
    this.logger_0.logInfo_puj7f4$(TAG, this.scanMessage_0(bleConnection, 'Message received: ' + messageProperties));
    if ((tmp$ = this.validate_0(messageProperties)) != null) {
      onError(tmp$);
      return;
    }if (messageProperties.needsResponce) {
      this.sendResponse_0(bleConnection, onError);
    }this.expectedUnum_0 = this.expectedUnum_0.nextOne();
    if (!messageProperties.isExtension) {
      this.bytesToSave_0 = plus(this.bytesToSave_0, bytebuffer.remainingBytes());
    } else {
      if (bytebuffer.get() === STATUS_EXTENSION) {
        if (getBit(bytebuffer.get(), 0)) {
          onError(null);
        }}}
  };
  function BleConnectionHandler$generateMessage$getBit($receiver) {
    return $receiver ? 1 : 0;
  }
  BleConnectionHandler.prototype.generateMessage_0 = function (command) {
    var tmp$;
    var getBit = BleConnectionHandler$generateMessage$getBit;
    var bit0 = getBit(this.dnum_0.firstBit());
    var bit1 = getBit(this.dnum_0.secondBit());
    var bit2 = getBit(this.expectedUnum_0.firstBit());
    var bit3 = getBit(this.expectedUnum_0.secondBit());
    var bit4 = getBit(command != null);
    var byte = toByte('000' + bit4 + bit3 + bit2 + bit1 + bit0, 2);
    return (tmp$ = command != null ? new Int8Array([byte, command]) : null) != null ? tmp$ : new Int8Array([byte]);
  };
  BleConnectionHandler.prototype.validate_0 = function (messageProperties) {
    if (this.expectedUnum_0 !== messageProperties.unum)
      return IllegalStateException_init('Incorrect unum, expected ' + this.expectedUnum_0 + ', actual ' + messageProperties.unum + ')');
    else if (this.dnum_0 !== messageProperties.dnum)
      return IllegalStateException_init('Incorrect dnum, expected ' + this.dnum_0 + ', actual ' + messageProperties.dnum);
    else
      return null;
  };
  function BleConnectionHandler$sendResponse$lambda(this$BleConnectionHandler) {
    return function () {
      this$BleConnectionHandler.dnum_0 = this$BleConnectionHandler.dnum_0.nextOne();
      return Unit;
    };
  }
  BleConnectionHandler.prototype.sendResponse_0 = function (bleConnection, onError) {
    this.sendCommand_0(bleConnection, this.generateMessage_0(null), onError, BleConnectionHandler$sendResponse$lambda(this));
  };
  BleConnectionHandler.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'BleConnectionHandler',
    interfaces: []
  };
  function MessageProperties(propertiesVarInt) {
    this.propertiesVarInt_0 = propertiesVarInt;
    this.dnum = getNumber(getBit_0(this.propertiesVarInt_0, 0), getBit_0(this.propertiesVarInt_0, 1));
    this.unum = getNumber(getBit_0(this.propertiesVarInt_0, 2), getBit_0(this.propertiesVarInt_0, 3));
    this.isExtension = getBit_0(this.propertiesVarInt_0, 4);
    this.needsResponce = getBit_0(this.propertiesVarInt_0, 5);
  }
  MessageProperties.prototype.toString = function () {
    return 'MessageProperties(dnum=' + this.dnum + ', unum=' + this.unum + ', needsResponce=' + this.needsResponce + ', isExtension=' + this.isExtension + ')';
  };
  MessageProperties.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'MessageProperties',
    interfaces: []
  };
  function getVarLong(src) {
    var tmp = {v: null};
    var $receiver = src.get();
    tmp.v = Kotlin.Long.fromInt($receiver);
    if ($receiver >= 0) {
      return tmp.v;
    }var result = tmp.v.and(L127);
    var $receiver_0 = src.get();
    tmp.v = Kotlin.Long.fromInt($receiver_0);
    if ($receiver_0 >= 0) {
      result = result.or(tmp.v.shiftLeft(7));
    } else {
      result = result.or(tmp.v.and(L127).shiftLeft(7));
      var $receiver_1 = src.get();
      tmp.v = Kotlin.Long.fromInt($receiver_1);
      if ($receiver_1 >= 0) {
        result = result.or(tmp.v.shiftLeft(14));
      } else {
        result = result.or(tmp.v.and(L127).shiftLeft(14));
        var $receiver_2 = src.get();
        tmp.v = Kotlin.Long.fromInt($receiver_2);
        if ($receiver_2 >= 0) {
          result = result.or(tmp.v.shiftLeft(21));
        } else {
          result = result.or(tmp.v.and(L127).shiftLeft(21));
          var $receiver_3 = src.get();
          tmp.v = Kotlin.Long.fromInt($receiver_3);
          if ($receiver_3 >= 0) {
            result = result.or(tmp.v.shiftLeft(28));
          } else {
            result = result.or(tmp.v.and(L127).shiftLeft(28));
            var $receiver_4 = src.get();
            tmp.v = Kotlin.Long.fromInt($receiver_4);
            if ($receiver_4 >= 0) {
              result = result.or(tmp.v.shiftLeft(35));
            } else {
              result = result.or(tmp.v.and(L127).shiftLeft(35));
              var $receiver_5 = src.get();
              tmp.v = Kotlin.Long.fromInt($receiver_5);
              if ($receiver_5 >= 0) {
                result = result.or(tmp.v.shiftLeft(42));
              } else {
                result = result.or(tmp.v.and(L127).shiftLeft(42));
                var $receiver_6 = src.get();
                tmp.v = Kotlin.Long.fromInt($receiver_6);
                if ($receiver_6 >= 0) {
                  result = result.or(tmp.v.shiftLeft(49));
                } else {
                  result = result.or(tmp.v.and(L127).shiftLeft(49));
                  var $receiver_7 = src.get();
                  tmp.v = Kotlin.Long.fromInt($receiver_7);
                  if ($receiver_7 >= 0) {
                    result = result.or(tmp.v.shiftLeft(56));
                  } else {
                    result = result.or(tmp.v.and(L127).shiftLeft(56));
                    result = result.or(Kotlin.Long.fromInt(src.get()).shiftLeft(63));
                  }
                }
              }
            }
          }
        }
      }
    }
    return result;
  }
  function getNumber(firstBit, secondBit) {
    if (secondBit) {
      if (firstBit) {
        return Number$NUM3_getInstance();
      } else {
        return Number$NUM2_getInstance();
      }
    } else {
      if (firstBit) {
        return Number$NUM1_getInstance();
      } else {
        return Number$NUM0_getInstance();
      }
    }
  }
  function Number_0(name, ordinal) {
    Enum.call(this);
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function Number_initFields() {
    Number_initFields = function () {
    };
    Number$NUM0_instance = new Number_0('NUM0', 0);
    Number$NUM1_instance = new Number_0('NUM1', 1);
    Number$NUM2_instance = new Number_0('NUM2', 2);
    Number$NUM3_instance = new Number_0('NUM3', 3);
  }
  var Number$NUM0_instance;
  function Number$NUM0_getInstance() {
    Number_initFields();
    return Number$NUM0_instance;
  }
  var Number$NUM1_instance;
  function Number$NUM1_getInstance() {
    Number_initFields();
    return Number$NUM1_instance;
  }
  var Number$NUM2_instance;
  function Number$NUM2_getInstance() {
    Number_initFields();
    return Number$NUM2_instance;
  }
  var Number$NUM3_instance;
  function Number$NUM3_getInstance() {
    Number_initFields();
    return Number$NUM3_instance;
  }
  Number_0.prototype.nextOne = function () {
    if (this.ordinal < get_lastIndex(Number$values())) {
      return Number$values()[this.ordinal + 1 | 0];
    } else {
      return Number$values()[0];
    }
  };
  Number_0.prototype.firstBit = function () {
    return this.ordinal % 2 === 1;
  };
  Number_0.prototype.secondBit = function () {
    return this.ordinal > 1;
  };
  Number_0.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Number',
    interfaces: [Enum]
  };
  function Number$values() {
    return [Number$NUM0_getInstance(), Number$NUM1_getInstance(), Number$NUM2_getInstance(), Number$NUM3_getInstance()];
  }
  Number_0.values = Number$values;
  function Number$valueOf(name) {
    switch (name) {
      case 'NUM0':
        return Number$NUM0_getInstance();
      case 'NUM1':
        return Number$NUM1_getInstance();
      case 'NUM2':
        return Number$NUM2_getInstance();
      case 'NUM3':
        return Number$NUM3_getInstance();
      default:throwISE('No enum constant io.moeco.sdk.bluetooth.connection.Number.' + name);
    }
  }
  Number_0.valueOf_61zpoe$ = Number$valueOf;
  function getBit($receiver, position) {
    return ($receiver >> position & 1) === 1;
  }
  function getBit_0($receiver, position) {
    return equals($receiver.shiftRight(position).and(L1), L1);
  }
  var START_COMMAND;
  var STATUS_EXTENSION;
  var TAG;
  function BleScanner() {
  }
  BleScanner.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'BleScanner',
    interfaces: []
  };
  var MOECO_MANUFACTURER_ID;
  var MOECO_SERVICE_ID;
  var MOECO_CHARACTERISTIC_ID;
  function MoecoBleScanner(bleScanner, timeoutSecondsProvider, stopFilter, filters) {
    if (stopFilter === void 0)
      stopFilter = null;
    this.bleScanner_0 = bleScanner;
    this.timeoutSecondsProvider_0 = timeoutSecondsProvider;
    this.stopFilter_0 = stopFilter;
    this.filters_0 = filters;
    this.allFilters_0 = plus_0(toList_0(this.filters_0), listOfNotNull(this.stopFilter_0));
  }
  function MoecoBleScanner$scanMoecoDevices$lambda(this$MoecoBleScanner) {
    return function (it) {
      var $receiver = this$MoecoBleScanner.allFilters_0;
      var all$result;
      all$break: do {
        var tmp$;
        if (Kotlin.isType($receiver, Collection) && $receiver.isEmpty()) {
          all$result = true;
          break all$break;
        }tmp$ = $receiver.iterator();
        while (tmp$.hasNext()) {
          var element = tmp$.next();
          if (!element.matches_sqncei$(it)) {
            all$result = false;
            break all$break;
          }}
        all$result = true;
      }
       while (false);
      return all$result;
    };
  }
  function MoecoBleScanner$scanMoecoDevices$lambda_0(this$MoecoBleScanner) {
    return function (it) {
      var tmp$, tmp$_0;
      return (tmp$_0 = (tmp$ = this$MoecoBleScanner.stopFilter_0) != null ? tmp$.matches_sqncei$(it) : null) != null ? tmp$_0 : false;
    };
  }
  function MoecoBleScanner$scanMoecoDevices$lambda_1(it) {
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(it, 10)), 16);
    var destination = LinkedHashMap_init(capacity);
    var tmp$;
    tmp$ = it.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      destination.put_xwzc9p$(element.address, element);
    }
    return toList_0(destination.values);
  }
  MoecoBleScanner.prototype.scanMoecoDevices = function () {
    var tmp$ = this.bleScanner_0.scanDevices();
    var $receiver = this.timeoutSecondsProvider_0.data;
    return map(toList(takeUntil(filter(takeUntil_0(tmp$, observableTimer(TimeSpan.Companion.fromSeconds_14dthe$($receiver).millisecondsLong, scheduler.ioScheduler)), MoecoBleScanner$scanMoecoDevices$lambda(this)), MoecoBleScanner$scanMoecoDevices$lambda_0(this))), MoecoBleScanner$scanMoecoDevices$lambda_1);
  };
  MoecoBleScanner.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'MoecoBleScanner',
    interfaces: []
  };
  function ManufacturerIdFilter(manufacturerId) {
    this.manufacturerId_0 = manufacturerId;
  }
  ManufacturerIdFilter.prototype.matches_sqncei$ = function (device) {
    var tmp$;
    return ((tmp$ = device.manufacturerData) != null ? tmp$.get_11rb$(this.manufacturerId_0) : null) != null;
  };
  ManufacturerIdFilter.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'ManufacturerIdFilter',
    interfaces: [ScanFilter]
  };
  function ScanFilter() {
  }
  ScanFilter.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'ScanFilter',
    interfaces: []
  };
  function UidFilter(uid) {
    this.uid_0 = uid;
  }
  UidFilter.prototype.matches_sqncei$ = function (device) {
    return equals(device.uid, this.uid_0);
  };
  UidFilter.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'UidFilter',
    interfaces: [ScanFilter]
  };
  function MoecoSdk(bleScanner, locationProvider, loggerDestinations) {
    this.bleScanner = bleScanner;
    this.locationProvider = locationProvider;
    this.loggerDestinations = loggerDestinations;
    this.logger = new LoggerImpl(toList_1(this.loggerDestinations));
    this.socketOpener = new KtorSocketOpener(this.logger);
    this.moecoMessagesEncoder = new MoecoMessagesEncoderImpl();
    this.moecoMessagesSender = new MessagesSender(this.socketOpener);
    this.timestampProvider = new MoecoSdk$timestampProvider$ObjectLiteral();
  }
  MoecoSdk.prototype.createMoecoBluetoothScanner_2zno6e$ = function (stopFilter, filters) {
    if (stopFilter === void 0)
      stopFilter = null;
    if (filters === void 0)
      filters = listOf(new ManufacturerIdFilter(1970));
    return new MoecoBleScanner(this.bleScanner, new CommonProvider(30), stopFilter, filters);
  };
  function MoecoSdk$startDeviceSynchronization$lambda(it) {
    var tmp$, tmp$_0;
    return (tmp$_0 = (tmp$ = firstOrNull(it)) != null ? tmp$.connect() : null) != null ? tmp$_0 : singleOfError(IllegalStateException_init('Device not found'));
  }
  function MoecoSdk$startDeviceSynchronization$lambda$lambda(this$MoecoSdk, closure$gatewayToken) {
    return function (bytes, location) {
      var tmp$;
      if (bytes != null) {
        var this$MoecoSdk_0 = this$MoecoSdk;
        tmp$ = this$MoecoSdk_0.moecoMessagesEncoder.encodeBytes_l65t2r$(bytes, location, closure$gatewayToken, this$MoecoSdk_0.timestampProvider.data);
      } else
        tmp$ = null;
      return tmp$;
    };
  }
  function MoecoSdk$startDeviceSynchronization$lambda_0(this$MoecoSdk, closure$gatewayToken) {
    return function (it) {
      return notNull(zip((new BleConnectionHandler(this$MoecoSdk.logger, it)).handleConnection(), this$MoecoSdk.locationProvider.provideLocation(), MoecoSdk$startDeviceSynchronization$lambda$lambda(this$MoecoSdk, closure$gatewayToken)));
    };
  }
  function MoecoSdk$startDeviceSynchronization$lambda$lambda_0(it) {
    return completableOfEmpty();
  }
  function MoecoSdk$startDeviceSynchronization$lambda_1(this$MoecoSdk, closure$serverInfo) {
    return function (it) {
      return this$MoecoSdk.moecoMessagesSender.sendMessages_tj36q1$(listOf(new CommonProvider(it)), closure$serverInfo, MoecoSdk$startDeviceSynchronization$lambda$lambda_0);
    };
  }
  MoecoSdk.prototype.startDeviceSynchronization = function (uid, gatewayToken, serverInfo, onSuccess, onError) {
    return subscribe_0(flatMapCompletable(flatMapMaybe(flatMap(this.createMoecoBluetoothScanner_2zno6e$(uid != null ? new UidFilter(uid) : null, emptyList()).scanMoecoDevices(), MoecoSdk$startDeviceSynchronization$lambda), MoecoSdk$startDeviceSynchronization$lambda_0(this, gatewayToken)), MoecoSdk$startDeviceSynchronization$lambda_1(this, serverInfo)), void 0, void 0, onError, onSuccess);
  };
  function MoecoSdk$timestampProvider$ObjectLiteral() {
  }
  Object.defineProperty(MoecoSdk$timestampProvider$ObjectLiteral.prototype, 'data', {
    configurable: true,
    get: function () {
      return DateTime.Companion.nowUnixLong();
    }
  });
  MoecoSdk$timestampProvider$ObjectLiteral.$metadata$ = {
    kind: Kind_CLASS,
    interfaces: [Provider]
  };
  MoecoSdk.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'MoecoSdk',
    interfaces: []
  };
  function LocationProvider() {
  }
  LocationProvider.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'LocationProvider',
    interfaces: []
  };
  function MoecoLocation(latitude, longitude) {
    this.latitude = latitude;
    this.longitude = longitude;
  }
  MoecoLocation.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'MoecoLocation',
    interfaces: []
  };
  MoecoLocation.prototype.component1 = function () {
    return this.latitude;
  };
  MoecoLocation.prototype.component2 = function () {
    return this.longitude;
  };
  MoecoLocation.prototype.copy_lu1900$ = function (latitude, longitude) {
    return new MoecoLocation(latitude === void 0 ? this.latitude : latitude, longitude === void 0 ? this.longitude : longitude);
  };
  MoecoLocation.prototype.toString = function () {
    return 'MoecoLocation(latitude=' + Kotlin.toString(this.latitude) + (', longitude=' + Kotlin.toString(this.longitude)) + ')';
  };
  MoecoLocation.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.latitude) | 0;
    result = result * 31 + Kotlin.hashCode(this.longitude) | 0;
    return result;
  };
  MoecoLocation.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.latitude, other.latitude) && Kotlin.equals(this.longitude, other.longitude)))));
  };
  function Logger() {
  }
  Logger.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'Logger',
    interfaces: []
  };
  function LoggerImpl(destinations) {
    this.destinations_0 = destinations;
  }
  LoggerImpl.prototype.logError_puj7f4$ = function (tag, msg) {
    this.logMessage_xrr0n5$(tag, msg, LogLevel$ERROR_getInstance());
  };
  LoggerImpl.prototype.logInfo_puj7f4$ = function (tag, msg) {
    this.logMessage_xrr0n5$(tag, msg, LogLevel$INFO_getInstance());
  };
  LoggerImpl.prototype.logDebug_puj7f4$ = function (tag, msg) {
    this.logMessage_xrr0n5$(tag, msg, LogLevel$DEBUG_getInstance());
  };
  function LoggerImpl$logMessage$lambda(this$LoggerImpl, closure$tag, closure$msg, closure$logLevel) {
    return function () {
      var tmp$;
      tmp$ = this$LoggerImpl.destinations_0.iterator();
      while (tmp$.hasNext()) {
        var destination = tmp$.next();
        destination.logMessage(closure$tag, closure$msg, closure$logLevel);
      }
      return Unit;
    };
  }
  LoggerImpl.prototype.logMessage_xrr0n5$ = function (tag, msg, logLevel) {
    subscribe_0(subscribeOn(completableFromFunction(LoggerImpl$logMessage$lambda(this, tag, msg, logLevel)), scheduler.ioScheduler));
  };
  LoggerImpl.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'LoggerImpl',
    interfaces: [Logger]
  };
  function LogLevel(name, ordinal, long) {
    Enum.call(this);
    this.long = long;
    this.name$ = name;
    this.ordinal$ = ordinal;
  }
  function LogLevel_initFields() {
    LogLevel_initFields = function () {
    };
    LogLevel$DEBUG_instance = new LogLevel('DEBUG', 0, L3);
    LogLevel$INFO_instance = new LogLevel('INFO', 1, L4);
    LogLevel$ERROR_instance = new LogLevel('ERROR', 2, L6);
  }
  var LogLevel$DEBUG_instance;
  function LogLevel$DEBUG_getInstance() {
    LogLevel_initFields();
    return LogLevel$DEBUG_instance;
  }
  var LogLevel$INFO_instance;
  function LogLevel$INFO_getInstance() {
    LogLevel_initFields();
    return LogLevel$INFO_instance;
  }
  var LogLevel$ERROR_instance;
  function LogLevel$ERROR_getInstance() {
    LogLevel_initFields();
    return LogLevel$ERROR_instance;
  }
  LogLevel.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'LogLevel',
    interfaces: [Enum]
  };
  function LogLevel$values() {
    return [LogLevel$DEBUG_getInstance(), LogLevel$INFO_getInstance(), LogLevel$ERROR_getInstance()];
  }
  LogLevel.values = LogLevel$values;
  function LogLevel$valueOf(name) {
    switch (name) {
      case 'DEBUG':
        return LogLevel$DEBUG_getInstance();
      case 'INFO':
        return LogLevel$INFO_getInstance();
      case 'ERROR':
        return LogLevel$ERROR_getInstance();
      default:throwISE('No enum constant io.moeco.sdk.logger.LogLevel.' + name);
    }
  }
  LogLevel.valueOf_61zpoe$ = LogLevel$valueOf;
  function LogDestination() {
  }
  LogDestination.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'LogDestination',
    interfaces: []
  };
  function GateMetaData(token, timestamp, gatewayData) {
    GateMetaData$Companion_getInstance();
    this.token = token;
    this.timestamp = timestamp;
    this.gatewayData_0 = gatewayData;
  }
  function GateMetaData$Companion() {
    GateMetaData$Companion_instance = this;
  }
  GateMetaData$Companion.prototype.serializer = function () {
    return GateMetaData$$serializer_getInstance();
  };
  GateMetaData$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var GateMetaData$Companion_instance = null;
  function GateMetaData$Companion_getInstance() {
    if (GateMetaData$Companion_instance === null) {
      new GateMetaData$Companion();
    }return GateMetaData$Companion_instance;
  }
  function GateMetaData$$serializer() {
    this.descriptor_46l6i0$_0 = new PluginGeneratedSerialDescriptor('io.moeco.sdk.messages.encoder.GateMetaData', this, 3);
    this.descriptor.addElement_ivxn3r$('gw_token', false);
    this.descriptor.addElement_ivxn3r$('timestamp_ms', false);
    this.descriptor.addElement_ivxn3r$('gw_data', false);
    GateMetaData$$serializer_instance = this;
  }
  Object.defineProperty(GateMetaData$$serializer.prototype, 'descriptor', {
    configurable: true,
    get: function () {
      return this.descriptor_46l6i0$_0;
    }
  });
  GateMetaData$$serializer.prototype.serialize_55azsf$ = function (encoder, value) {
    var output = encoder.beginStructure_24f42q$(this.descriptor);
    output.encodeStringElement_iij8qq$(this.descriptor, 0, value.token);
    output.encodeLongElement_j0o2mv$(this.descriptor, 1, value.timestamp);
    output.encodeSerializableElement_r4qlx7$(this.descriptor, 2, GatewayData$$serializer_getInstance(), value.gatewayData_0);
    output.endStructure_24f42q$(this.descriptor);
  };
  GateMetaData$$serializer.prototype.deserialize_bq71mq$ = function (decoder) {
    var index;
    var bitMask0 = 0;
    var local0
    , local1
    , local2;
    var input = decoder.beginStructure_24f42q$(this.descriptor);
    loopLabel: while (true) {
      index = input.decodeElementIndex_24f42q$(this.descriptor);
      switch (index) {
        case 0:
          local0 = input.decodeStringElement_szpzho$(this.descriptor, 0);
          bitMask0 |= 1;
          break;
        case 1:
          local1 = input.decodeLongElement_szpzho$(this.descriptor, 1);
          bitMask0 |= 2;
          break;
        case 2:
          local2 = input.decodeSerializableElement_12e8id$(this.descriptor, 2, GatewayData$$serializer_getInstance(), local2);
          bitMask0 |= 4;
          break;
        case -1:
          break loopLabel;
        default:throw new UnknownFieldException(index);
      }
    }
    input.endStructure_24f42q$(this.descriptor);
    return GateMetaData_init(bitMask0, local0, local1, local2, null);
  };
  GateMetaData$$serializer.prototype.childSerializers = function () {
    return [internal.StringSerializer, internal.LongSerializer, GatewayData$$serializer_getInstance()];
  };
  GateMetaData$$serializer.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: '$serializer',
    interfaces: [GeneratedSerializer]
  };
  var GateMetaData$$serializer_instance = null;
  function GateMetaData$$serializer_getInstance() {
    if (GateMetaData$$serializer_instance === null) {
      new GateMetaData$$serializer();
    }return GateMetaData$$serializer_instance;
  }
  function GateMetaData_init(seen1, token, timestamp, gatewayData, serializationConstructorMarker) {
    var $this = serializationConstructorMarker || Object.create(GateMetaData.prototype);
    if ((seen1 & 1) === 0)
      throw MissingFieldException_init('gw_token');
    else
      $this.token = token;
    if ((seen1 & 2) === 0)
      throw MissingFieldException_init('timestamp_ms');
    else
      $this.timestamp = timestamp;
    if ((seen1 & 4) === 0)
      throw MissingFieldException_init('gw_data');
    else
      $this.gatewayData_0 = gatewayData;
    return $this;
  }
  GateMetaData.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'GateMetaData',
    interfaces: []
  };
  function GateMetaData_init_0(token, timestamp, latitude, longitude, $this) {
    $this = $this || Object.create(GateMetaData.prototype);
    GateMetaData.call($this, token, timestamp, new GatewayData(new Geolocation(latitude, longitude)));
    return $this;
  }
  GateMetaData.prototype.component1 = function () {
    return this.token;
  };
  GateMetaData.prototype.component2 = function () {
    return this.timestamp;
  };
  GateMetaData.prototype.component3_0 = function () {
    return this.gatewayData_0;
  };
  GateMetaData.prototype.copy_wnn5lo$ = function (token, timestamp, gatewayData) {
    return new GateMetaData(token === void 0 ? this.token : token, timestamp === void 0 ? this.timestamp : timestamp, gatewayData === void 0 ? this.gatewayData_0 : gatewayData);
  };
  GateMetaData.prototype.toString = function () {
    return 'GateMetaData(token=' + Kotlin.toString(this.token) + (', timestamp=' + Kotlin.toString(this.timestamp)) + (', gatewayData=' + Kotlin.toString(this.gatewayData_0)) + ')';
  };
  GateMetaData.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.token) | 0;
    result = result * 31 + Kotlin.hashCode(this.timestamp) | 0;
    result = result * 31 + Kotlin.hashCode(this.gatewayData_0) | 0;
    return result;
  };
  GateMetaData.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.token, other.token) && Kotlin.equals(this.timestamp, other.timestamp) && Kotlin.equals(this.gatewayData_0, other.gatewayData_0)))));
  };
  function GatewayData(geolocation) {
    GatewayData$Companion_getInstance();
    this.geolocation = geolocation;
  }
  function GatewayData$Companion() {
    GatewayData$Companion_instance = this;
  }
  GatewayData$Companion.prototype.serializer = function () {
    return GatewayData$$serializer_getInstance();
  };
  GatewayData$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var GatewayData$Companion_instance = null;
  function GatewayData$Companion_getInstance() {
    if (GatewayData$Companion_instance === null) {
      new GatewayData$Companion();
    }return GatewayData$Companion_instance;
  }
  function GatewayData$$serializer() {
    this.descriptor_6ocqxm$_0 = new PluginGeneratedSerialDescriptor('io.moeco.sdk.messages.encoder.GatewayData', this, 1);
    this.descriptor.addElement_ivxn3r$('geolocation', false);
    GatewayData$$serializer_instance = this;
  }
  Object.defineProperty(GatewayData$$serializer.prototype, 'descriptor', {
    configurable: true,
    get: function () {
      return this.descriptor_6ocqxm$_0;
    }
  });
  GatewayData$$serializer.prototype.serialize_55azsf$ = function (encoder, value) {
    var output = encoder.beginStructure_24f42q$(this.descriptor);
    output.encodeSerializableElement_r4qlx7$(this.descriptor, 0, Geolocation$$serializer_getInstance(), value.geolocation);
    output.endStructure_24f42q$(this.descriptor);
  };
  GatewayData$$serializer.prototype.deserialize_bq71mq$ = function (decoder) {
    var index;
    var bitMask0 = 0;
    var local0;
    var input = decoder.beginStructure_24f42q$(this.descriptor);
    loopLabel: while (true) {
      index = input.decodeElementIndex_24f42q$(this.descriptor);
      switch (index) {
        case 0:
          local0 = input.decodeSerializableElement_12e8id$(this.descriptor, 0, Geolocation$$serializer_getInstance(), local0);
          bitMask0 |= 1;
          break;
        case -1:
          break loopLabel;
        default:throw new UnknownFieldException(index);
      }
    }
    input.endStructure_24f42q$(this.descriptor);
    return GatewayData_init(bitMask0, local0, null);
  };
  GatewayData$$serializer.prototype.childSerializers = function () {
    return [Geolocation$$serializer_getInstance()];
  };
  GatewayData$$serializer.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: '$serializer',
    interfaces: [GeneratedSerializer]
  };
  var GatewayData$$serializer_instance = null;
  function GatewayData$$serializer_getInstance() {
    if (GatewayData$$serializer_instance === null) {
      new GatewayData$$serializer();
    }return GatewayData$$serializer_instance;
  }
  function GatewayData_init(seen1, geolocation, serializationConstructorMarker) {
    var $this = serializationConstructorMarker || Object.create(GatewayData.prototype);
    if ((seen1 & 1) === 0)
      throw MissingFieldException_init('geolocation');
    else
      $this.geolocation = geolocation;
    return $this;
  }
  GatewayData.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'GatewayData',
    interfaces: []
  };
  GatewayData.prototype.component1 = function () {
    return this.geolocation;
  };
  GatewayData.prototype.copy_e8tost$ = function (geolocation) {
    return new GatewayData(geolocation === void 0 ? this.geolocation : geolocation);
  };
  GatewayData.prototype.toString = function () {
    return 'GatewayData(geolocation=' + Kotlin.toString(this.geolocation) + ')';
  };
  GatewayData.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.geolocation) | 0;
    return result;
  };
  GatewayData.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && Kotlin.equals(this.geolocation, other.geolocation))));
  };
  function Geolocation(lat, long) {
    Geolocation$Companion_getInstance();
    this.lat = lat;
    this.long = long;
  }
  function Geolocation$Companion() {
    Geolocation$Companion_instance = this;
  }
  Geolocation$Companion.prototype.serializer = function () {
    return Geolocation$$serializer_getInstance();
  };
  Geolocation$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var Geolocation$Companion_instance = null;
  function Geolocation$Companion_getInstance() {
    if (Geolocation$Companion_instance === null) {
      new Geolocation$Companion();
    }return Geolocation$Companion_instance;
  }
  function Geolocation$$serializer() {
    this.descriptor_tgmziq$_0 = new PluginGeneratedSerialDescriptor('io.moeco.sdk.messages.encoder.Geolocation', this, 2);
    this.descriptor.addElement_ivxn3r$('lat', false);
    this.descriptor.addElement_ivxn3r$('long', false);
    Geolocation$$serializer_instance = this;
  }
  Object.defineProperty(Geolocation$$serializer.prototype, 'descriptor', {
    configurable: true,
    get: function () {
      return this.descriptor_tgmziq$_0;
    }
  });
  Geolocation$$serializer.prototype.serialize_55azsf$ = function (encoder, value) {
    var output = encoder.beginStructure_24f42q$(this.descriptor);
    output.encodeDoubleElement_powrwi$(this.descriptor, 0, value.lat);
    output.encodeDoubleElement_powrwi$(this.descriptor, 1, value.long);
    output.endStructure_24f42q$(this.descriptor);
  };
  Geolocation$$serializer.prototype.deserialize_bq71mq$ = function (decoder) {
    var index;
    var bitMask0 = 0;
    var local0
    , local1;
    var input = decoder.beginStructure_24f42q$(this.descriptor);
    loopLabel: while (true) {
      index = input.decodeElementIndex_24f42q$(this.descriptor);
      switch (index) {
        case 0:
          local0 = input.decodeDoubleElement_szpzho$(this.descriptor, 0);
          bitMask0 |= 1;
          break;
        case 1:
          local1 = input.decodeDoubleElement_szpzho$(this.descriptor, 1);
          bitMask0 |= 2;
          break;
        case -1:
          break loopLabel;
        default:throw new UnknownFieldException(index);
      }
    }
    input.endStructure_24f42q$(this.descriptor);
    return Geolocation_init(bitMask0, local0, local1, null);
  };
  Geolocation$$serializer.prototype.childSerializers = function () {
    return [internal.DoubleSerializer, internal.DoubleSerializer];
  };
  Geolocation$$serializer.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: '$serializer',
    interfaces: [GeneratedSerializer]
  };
  var Geolocation$$serializer_instance = null;
  function Geolocation$$serializer_getInstance() {
    if (Geolocation$$serializer_instance === null) {
      new Geolocation$$serializer();
    }return Geolocation$$serializer_instance;
  }
  function Geolocation_init(seen1, lat, long, serializationConstructorMarker) {
    var $this = serializationConstructorMarker || Object.create(Geolocation.prototype);
    if ((seen1 & 1) === 0)
      throw MissingFieldException_init('lat');
    else
      $this.lat = lat;
    if ((seen1 & 2) === 0)
      throw MissingFieldException_init('long');
    else
      $this.long = long;
    return $this;
  }
  Geolocation.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Geolocation',
    interfaces: []
  };
  Geolocation.prototype.component1 = function () {
    return this.lat;
  };
  Geolocation.prototype.component2 = function () {
    return this.long;
  };
  Geolocation.prototype.copy_lu1900$ = function (lat, long) {
    return new Geolocation(lat === void 0 ? this.lat : lat, long === void 0 ? this.long : long);
  };
  Geolocation.prototype.toString = function () {
    return 'Geolocation(lat=' + Kotlin.toString(this.lat) + (', long=' + Kotlin.toString(this.long)) + ')';
  };
  Geolocation.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.lat) | 0;
    result = result * 31 + Kotlin.hashCode(this.long) | 0;
    return result;
  };
  Geolocation.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.lat, other.lat) && Kotlin.equals(this.long, other.long)))));
  };
  function GatewayMessage(message, metadata) {
    GatewayMessage$Companion_getInstance();
    if (message === void 0)
      message = null;
    if (metadata === void 0)
      metadata = null;
    this.message = message;
    this.metadata = metadata;
  }
  function GatewayMessage$Companion() {
    GatewayMessage$Companion_instance = this;
  }
  GatewayMessage$Companion.prototype.serializer = function () {
    return GatewayMessage$$serializer_getInstance();
  };
  GatewayMessage$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var GatewayMessage$Companion_instance = null;
  function GatewayMessage$Companion_getInstance() {
    if (GatewayMessage$Companion_instance === null) {
      new GatewayMessage$Companion();
    }return GatewayMessage$Companion_instance;
  }
  function GatewayMessage$$serializer() {
    this.descriptor_u3n7gh$_0 = new PluginGeneratedSerialDescriptor('io.moeco.sdk.messages.encoder.GatewayMessage', this, 2);
    this.descriptor.addElement_ivxn3r$('message', true);
    this.descriptor.addElement_ivxn3r$('metadata', true);
    GatewayMessage$$serializer_instance = this;
  }
  Object.defineProperty(GatewayMessage$$serializer.prototype, 'descriptor', {
    configurable: true,
    get: function () {
      return this.descriptor_u3n7gh$_0;
    }
  });
  GatewayMessage$$serializer.prototype.serialize_55azsf$ = function (encoder, value) {
    var output = encoder.beginStructure_24f42q$(this.descriptor);
    if (!equals(value.message, null) || output.shouldEncodeElementDefault_szpzho$(this.descriptor, 0))
      output.encodeNullableSerializableElement_qw92s8$(this.descriptor, 0, internal.ByteArraySerializer, value.message);
    if (!equals(value.metadata, null) || output.shouldEncodeElementDefault_szpzho$(this.descriptor, 1))
      output.encodeNullableSerializableElement_qw92s8$(this.descriptor, 1, internal.StringSerializer, value.metadata);
    output.endStructure_24f42q$(this.descriptor);
  };
  GatewayMessage$$serializer.prototype.deserialize_bq71mq$ = function (decoder) {
    var index;
    var bitMask0 = 0;
    var local0
    , local1;
    var input = decoder.beginStructure_24f42q$(this.descriptor);
    loopLabel: while (true) {
      index = input.decodeElementIndex_24f42q$(this.descriptor);
      switch (index) {
        case 0:
          local0 = input.decodeNullableSerializableElement_8viuyw$(this.descriptor, 0, internal.ByteArraySerializer, local0);
          bitMask0 |= 1;
          break;
        case 1:
          local1 = input.decodeNullableSerializableElement_8viuyw$(this.descriptor, 1, internal.StringSerializer, local1);
          bitMask0 |= 2;
          break;
        case -1:
          break loopLabel;
        default:throw new UnknownFieldException(index);
      }
    }
    input.endStructure_24f42q$(this.descriptor);
    return GatewayMessage_init(bitMask0, local0, local1, null);
  };
  GatewayMessage$$serializer.prototype.childSerializers = function () {
    return [new NullableSerializer(internal.ByteArraySerializer), new NullableSerializer(internal.StringSerializer)];
  };
  GatewayMessage$$serializer.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: '$serializer',
    interfaces: [GeneratedSerializer]
  };
  var GatewayMessage$$serializer_instance = null;
  function GatewayMessage$$serializer_getInstance() {
    if (GatewayMessage$$serializer_instance === null) {
      new GatewayMessage$$serializer();
    }return GatewayMessage$$serializer_instance;
  }
  function GatewayMessage_init(seen1, message, metadata, serializationConstructorMarker) {
    var $this = serializationConstructorMarker || Object.create(GatewayMessage.prototype);
    if ((seen1 & 1) === 0)
      $this.message = null;
    else
      $this.message = message;
    if ((seen1 & 2) === 0)
      $this.metadata = null;
    else
      $this.metadata = metadata;
    return $this;
  }
  GatewayMessage.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'GatewayMessage',
    interfaces: []
  };
  GatewayMessage.prototype.component1 = function () {
    return this.message;
  };
  GatewayMessage.prototype.component2 = function () {
    return this.metadata;
  };
  GatewayMessage.prototype.copy_y0e8xe$ = function (message, metadata) {
    return new GatewayMessage(message === void 0 ? this.message : message, metadata === void 0 ? this.metadata : metadata);
  };
  GatewayMessage.prototype.toString = function () {
    return 'GatewayMessage(message=' + Kotlin.toString(this.message) + (', metadata=' + Kotlin.toString(this.metadata)) + ')';
  };
  GatewayMessage.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.message) | 0;
    result = result * 31 + Kotlin.hashCode(this.metadata) | 0;
    return result;
  };
  GatewayMessage.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.message, other.message) && Kotlin.equals(this.metadata, other.metadata)))));
  };
  function MoecoMessagesEncoder() {
  }
  MoecoMessagesEncoder.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'MoecoMessagesEncoder',
    interfaces: []
  };
  function MoecoMessagesEncoderImpl() {
  }
  MoecoMessagesEncoderImpl.prototype.encodeBytes_l65t2r$ = function (message, location, gatewayToken, timestamp) {
    var tmp$ = ProtoBuf.Default;
    var $receiver = Json.Default;
    var value = GateMetaData_init_0(gatewayToken, timestamp, location.latitude, location.longitude);
    var tmp$_0;
    var value_0 = new GatewayMessage(message, $receiver.encodeToString_tf03ej$(Kotlin.isType(tmp$_0 = serializer($receiver.serializersModule, createKType(getKClass(GateMetaData), [], false)), KSerializer) ? tmp$_0 : throwCCE(), value));
    var tmp$_1;
    return tmp$.encodeToByteArray_tf03ej$(Kotlin.isType(tmp$_1 = serializer(tmp$.serializersModule, createKType(getKClass(GatewayMessage), [], false)), KSerializer) ? tmp$_1 : throwCCE(), value_0);
  };
  MoecoMessagesEncoderImpl.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'MoecoMessagesEncoderImpl',
    interfaces: [MoecoMessagesEncoder]
  };
  function MessagesSender(socketOpener) {
    this.socketOpener_0 = socketOpener;
  }
  function MessagesSender$sendMessages$lambda$lambda(closure$socket) {
    return function () {
      closure$socket.close();
      return Unit;
    };
  }
  function MessagesSender$sendMessages$lambda(closure$bytesSources, closure$onEachSent) {
    return function (socket) {
      var $receiver = closure$bytesSources;
      var destination = ArrayList_init(collectionSizeOrDefault($receiver, 10));
      var tmp$;
      tmp$ = $receiver.iterator();
      while (tmp$.hasNext()) {
        var item = tmp$.next();
        var tmp$_0 = destination.add_11rb$;
        var closure$onEachSent_0 = closure$onEachSent;
        tmp$_0.call(destination, andThen(socket.write_fqrh44$(item.data), closure$onEachSent_0(item)));
      }
      return andThen(concat(destination), completableFromFunction(MessagesSender$sendMessages$lambda$lambda(socket)));
    };
  }
  MessagesSender.prototype.sendMessages_tj36q1$ = function (bytesSources, serverInfo, onEachSent) {
    return flatMapCompletable_0(this.socketOpener_0.openSocket_16bsan$(serverInfo), MessagesSender$sendMessages$lambda(bytesSources, onEachSent));
  };
  MessagesSender.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'MessagesSender',
    interfaces: []
  };
  function Provider() {
  }
  Provider.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'Provider',
    interfaces: []
  };
  function CommonProvider(data) {
    this.data_zanucn$_0 = data;
  }
  Object.defineProperty(CommonProvider.prototype, 'data', {
    get: function () {
      return this.data_zanucn$_0;
    }
  });
  CommonProvider.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'CommonProvider',
    interfaces: [Provider]
  };
  function SocketOpener() {
  }
  SocketOpener.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'SocketOpener',
    interfaces: []
  };
  function Socket() {
  }
  Socket.$metadata$ = {
    kind: Kind_INTERFACE,
    simpleName: 'Socket',
    interfaces: []
  };
  function KtorSocketOpener(logger) {
    this.logger_0 = logger;
    this.client_0 = HttpClient(KtorSocketOpener$client$lambda);
  }
  function KtorSocketOpener$openSocket$lambda$lambda$lambda$lambda($receiver, it) {
    $receiver.protocol = URLProtocol.Companion.WSS;
    return Unit;
  }
  function KtorSocketOpener$openSocket$lambda$lambda$lambda($receiver) {
    $receiver.url_6yzzjr$(KtorSocketOpener$openSocket$lambda$lambda$lambda$lambda);
    return Unit;
  }
  function Coroutine$KtorSocketOpener$openSocket$lambda$lambda(this$KtorSocketOpener_0, closure$serverInfo_0, closure$emitter_0, $receiver_0, controller, continuation_0) {
    CoroutineImpl.call(this, continuation_0);
    this.$controller = controller;
    this.exceptionState_0 = 5;
    this.local$this$KtorSocketOpener = this$KtorSocketOpener_0;
    this.local$closure$serverInfo = closure$serverInfo_0;
    this.local$closure$emitter = closure$emitter_0;
  }
  Coroutine$KtorSocketOpener$openSocket$lambda$lambda.$metadata$ = {
    kind: Kotlin.Kind.CLASS,
    simpleName: null,
    interfaces: [CoroutineImpl]
  };
  Coroutine$KtorSocketOpener$openSocket$lambda$lambda.prototype = Object.create(CoroutineImpl.prototype);
  Coroutine$KtorSocketOpener$openSocket$lambda$lambda.prototype.constructor = Coroutine$KtorSocketOpener$openSocket$lambda$lambda;
  Coroutine$KtorSocketOpener$openSocket$lambda$lambda.prototype.doResume = function () {
    do
      try {
        switch (this.state_0) {
          case 0:
            this.exceptionState_0 = 2;
            this.state_0 = 1;
            this.result_0 = webSocketSession(this.local$this$KtorSocketOpener.client_0, void 0, this.local$closure$serverInfo.address, this.local$closure$serverInfo.port, void 0, KtorSocketOpener$openSocket$lambda$lambda$lambda, this);
            if (this.result_0 === COROUTINE_SUSPENDED)
              return COROUTINE_SUSPENDED;
            continue;
          case 1:
            var session = this.result_0;
            this.local$this$KtorSocketOpener.logger_0.logInfo_puj7f4$(TAG_0, 'Connected to socket');
            return this.local$closure$emitter.onSuccess_11rb$(new KtorSocket(session, this.local$this$KtorSocketOpener.logger_0)), Unit;
          case 2:
            this.exceptionState_0 = 5;
            var ex = this.exception_0;
            if (Kotlin.isType(ex, Throwable)) {
              this.local$this$KtorSocketOpener.logger_0.logInfo_puj7f4$(TAG_0, 'Error while connecting to socket, ' + ex);
              return this.local$closure$emitter.onError_tcv7n7$(ex), Unit;
            } else {
              throw ex;
            }

          case 3:
            this.state_0 = 4;
            continue;
          case 4:
            return;
          case 5:
            throw this.exception_0;
          default:this.state_0 = 5;
            throw new Error('State Machine Unreachable execution');
        }
      } catch (e) {
        if (this.state_0 === 5) {
          this.exceptionState_0 = this.state_0;
          throw e;
        } else {
          this.state_0 = this.exceptionState_0;
          this.exception_0 = e;
        }
      }
     while (true);
  };
  function KtorSocketOpener$openSocket$lambda$lambda(this$KtorSocketOpener_0, closure$serverInfo_0, closure$emitter_0) {
    return function ($receiver_0, continuation_0, suspended) {
      var instance = new Coroutine$KtorSocketOpener$openSocket$lambda$lambda(this$KtorSocketOpener_0, closure$serverInfo_0, closure$emitter_0, $receiver_0, this, continuation_0);
      if (suspended)
        return instance;
      else
        return instance.doResume(null);
    };
  }
  function KtorSocketOpener$openSocket$lambda(this$KtorSocketOpener, closure$serverInfo) {
    return function (emitter) {
      launch(this$KtorSocketOpener.client_0, void 0, void 0, KtorSocketOpener$openSocket$lambda$lambda(this$KtorSocketOpener, closure$serverInfo, emitter));
      return Unit;
    };
  }
  KtorSocketOpener.prototype.openSocket_16bsan$ = function (serverInfo) {
    return single(KtorSocketOpener$openSocket$lambda(this, serverInfo));
  };
  function KtorSocketOpener$client$lambda($receiver) {
    $receiver.install_xlxg29$(WebSockets.Feature);
    return Unit;
  }
  KtorSocketOpener.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'KtorSocketOpener',
    interfaces: [SocketOpener]
  };
  function KtorSocket(session, logger) {
    this.session_0 = session;
    this.logger_0 = logger;
  }
  function Coroutine$KtorSocket$write$lambda$lambda(this$KtorSocket_0, closure$bytes_0, closure$emitter_0, $receiver_0, controller, continuation_0) {
    CoroutineImpl.call(this, continuation_0);
    this.$controller = controller;
    this.exceptionState_0 = 5;
    this.local$this$KtorSocket = this$KtorSocket_0;
    this.local$closure$bytes = closure$bytes_0;
    this.local$closure$emitter = closure$emitter_0;
  }
  Coroutine$KtorSocket$write$lambda$lambda.$metadata$ = {
    kind: Kotlin.Kind.CLASS,
    simpleName: null,
    interfaces: [CoroutineImpl]
  };
  Coroutine$KtorSocket$write$lambda$lambda.prototype = Object.create(CoroutineImpl.prototype);
  Coroutine$KtorSocket$write$lambda$lambda.prototype.constructor = Coroutine$KtorSocket$write$lambda$lambda;
  Coroutine$KtorSocket$write$lambda$lambda.prototype.doResume = function () {
    do
      try {
        switch (this.state_0) {
          case 0:
            this.exceptionState_0 = 2;
            this.state_0 = 1;
            this.result_0 = send(this.local$this$KtorSocket.session_0, this.local$closure$bytes, this);
            if (this.result_0 === COROUTINE_SUSPENDED)
              return COROUTINE_SUSPENDED;
            continue;
          case 1:
            this.local$this$KtorSocket.logger_0.logInfo_puj7f4$(TAG_0, this.local$closure$bytes.length.toString() + ' bytes sent to socket');
            return this.local$closure$emitter.onComplete(), Unit;
          case 2:
            this.exceptionState_0 = 5;
            var ex = this.exception_0;
            if (Kotlin.isType(ex, Throwable)) {
              this.local$this$KtorSocket.logger_0.logInfo_puj7f4$(TAG_0, 'Error while sending bytes, ' + ex);
              return this.local$closure$emitter.onError_tcv7n7$(ex), Unit;
            } else {
              throw ex;
            }

          case 3:
            this.state_0 = 4;
            continue;
          case 4:
            return;
          case 5:
            throw this.exception_0;
          default:this.state_0 = 5;
            throw new Error('State Machine Unreachable execution');
        }
      } catch (e) {
        if (this.state_0 === 5) {
          this.exceptionState_0 = this.state_0;
          throw e;
        } else {
          this.state_0 = this.exceptionState_0;
          this.exception_0 = e;
        }
      }
     while (true);
  };
  function KtorSocket$write$lambda$lambda(this$KtorSocket_0, closure$bytes_0, closure$emitter_0) {
    return function ($receiver_0, continuation_0, suspended) {
      var instance = new Coroutine$KtorSocket$write$lambda$lambda(this$KtorSocket_0, closure$bytes_0, closure$emitter_0, $receiver_0, this, continuation_0);
      if (suspended)
        return instance;
      else
        return instance.doResume(null);
    };
  }
  function KtorSocket$write$lambda(this$KtorSocket, closure$bytes) {
    return function (emitter) {
      launch(this$KtorSocket.session_0, void 0, void 0, KtorSocket$write$lambda$lambda(this$KtorSocket, closure$bytes, emitter));
      return Unit;
    };
  }
  KtorSocket.prototype.write_fqrh44$ = function (bytes) {
    return completable(KtorSocket$write$lambda(this, bytes));
  };
  function Coroutine$KtorSocket$close$lambda$lambda(this$KtorSocket_0, closure$emitter_0, $receiver_0, controller, continuation_0) {
    CoroutineImpl.call(this, continuation_0);
    this.$controller = controller;
    this.exceptionState_0 = 6;
    this.local$this$KtorSocket = this$KtorSocket_0;
    this.local$closure$emitter = closure$emitter_0;
  }
  Coroutine$KtorSocket$close$lambda$lambda.$metadata$ = {
    kind: Kotlin.Kind.CLASS,
    simpleName: null,
    interfaces: [CoroutineImpl]
  };
  Coroutine$KtorSocket$close$lambda$lambda.prototype = Object.create(CoroutineImpl.prototype);
  Coroutine$KtorSocket$close$lambda$lambda.prototype.constructor = Coroutine$KtorSocket$close$lambda$lambda;
  Coroutine$KtorSocket$close$lambda$lambda.prototype.doResume = function () {
    do
      try {
        switch (this.state_0) {
          case 0:
            this.exceptionState_0 = 3;
            this.state_0 = 1;
            this.result_0 = this.local$this$KtorSocket.session_0.flush(this);
            if (this.result_0 === COROUTINE_SUSPENDED)
              return COROUTINE_SUSPENDED;
            continue;
          case 1:
            this.state_0 = 2;
            this.result_0 = close(this.local$this$KtorSocket.session_0, void 0, this);
            if (this.result_0 === COROUTINE_SUSPENDED)
              return COROUTINE_SUSPENDED;
            continue;
          case 2:
            this.local$this$KtorSocket.logger_0.logInfo_puj7f4$(TAG_0, 'Socket disconnected');
            return this.local$closure$emitter.onComplete(), Unit;
          case 3:
            this.exceptionState_0 = 6;
            var ex = this.exception_0;
            if (Kotlin.isType(ex, Throwable)) {
              this.local$this$KtorSocket.logger_0.logInfo_puj7f4$(TAG_0, 'Error while closing socket, ' + ex);
              return this.local$closure$emitter.onError_tcv7n7$(ex), Unit;
            } else {
              throw ex;
            }

          case 4:
            this.state_0 = 5;
            continue;
          case 5:
            return;
          case 6:
            throw this.exception_0;
          default:this.state_0 = 6;
            throw new Error('State Machine Unreachable execution');
        }
      } catch (e) {
        if (this.state_0 === 6) {
          this.exceptionState_0 = this.state_0;
          throw e;
        } else {
          this.state_0 = this.exceptionState_0;
          this.exception_0 = e;
        }
      }
     while (true);
  };
  function KtorSocket$close$lambda$lambda(this$KtorSocket_0, closure$emitter_0) {
    return function ($receiver_0, continuation_0, suspended) {
      var instance = new Coroutine$KtorSocket$close$lambda$lambda(this$KtorSocket_0, closure$emitter_0, $receiver_0, this, continuation_0);
      if (suspended)
        return instance;
      else
        return instance.doResume(null);
    };
  }
  function KtorSocket$close$lambda(this$KtorSocket) {
    return function (emitter) {
      launch(this$KtorSocket.session_0, void 0, void 0, KtorSocket$close$lambda$lambda(this$KtorSocket, emitter));
      return Unit;
    };
  }
  KtorSocket.prototype.close = function () {
    return completable(KtorSocket$close$lambda(this));
  };
  KtorSocket.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'KtorSocket',
    interfaces: [Socket]
  };
  var TAG_0;
  function ServerInfo(address, port) {
    this.address = address;
    this.port = port;
  }
  ServerInfo.prototype.getAddressString = function () {
    return this.address + ':' + this.port;
  };
  ServerInfo.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'ServerInfo',
    interfaces: []
  };
  ServerInfo.prototype.component1 = function () {
    return this.address;
  };
  ServerInfo.prototype.component2 = function () {
    return this.port;
  };
  ServerInfo.prototype.copy_bm4lxs$ = function (address, port) {
    return new ServerInfo(address === void 0 ? this.address : address, port === void 0 ? this.port : port);
  };
  ServerInfo.prototype.toString = function () {
    return 'ServerInfo(address=' + Kotlin.toString(this.address) + (', port=' + Kotlin.toString(this.port)) + ')';
  };
  ServerInfo.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.address) | 0;
    result = result * 31 + Kotlin.hashCode(this.port) | 0;
    return result;
  };
  ServerInfo.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.address, other.address) && Kotlin.equals(this.port, other.port)))));
  };
  var package$io = _.io || (_.io = {});
  var package$moeco = package$io.moeco || (package$io.moeco = {});
  var package$sdk = package$moeco.sdk || (package$moeco.sdk = {});
  package$sdk.Atomic = Atomic;
  package$sdk.ByteBuffer = ByteBuffer;
  package$sdk.moecoObservable = moecoObservable;
  package$sdk.moecoSingle = moecoSingle;
  package$sdk.moecoCompletable = moecoCompletable;
  package$sdk.PlatformScanner = PlatformScanner;
  package$sdk.PlatformBleScanner = PlatformBleScanner;
  $$importsForInline$$['Reaktive-reaktive-js-legacy'] = $module$Reaktive_reaktive_js_legacy;
  package$sdk.MoecoObservableEmitter = MoecoObservableEmitter;
  package$sdk.MoecoSingleEmitter = MoecoSingleEmitter;
  package$sdk.MoecoCompletableEmitter = MoecoCompletableEmitter;
  var package$bluetooth = package$sdk.bluetooth || (package$sdk.bluetooth = {});
  package$bluetooth.BleDevice = BleDevice;
  var package$connection = package$bluetooth.connection || (package$bluetooth.connection = {});
  package$connection.BleConnection = BleConnection;
  Object.defineProperty(BleConnectionState, 'BleConnectedState', {
    get: BleConnectionState$BleConnectedState_getInstance
  });
  Object.defineProperty(BleConnectionState, 'BleDisconnectedState', {
    get: BleConnectionState$BleDisconnectedState_getInstance
  });
  package$connection.BleConnectionState = BleConnectionState;
  package$connection.MoecoBleCharacteristic = MoecoBleCharacteristic;
  package$connection.BleConnectionHandler = BleConnectionHandler;
  package$connection.getVarLong_t43xp9$ = getVarLong;
  Object.defineProperty(package$connection, 'START_COMMAND', {
    get: function () {
      return START_COMMAND;
    }
  });
  Object.defineProperty(package$connection, 'STATUS_EXTENSION', {
    get: function () {
      return STATUS_EXTENSION;
    }
  });
  var package$scan = package$bluetooth.scan || (package$bluetooth.scan = {});
  package$scan.BleScanner = BleScanner;
  Object.defineProperty(package$scan, 'MOECO_MANUFACTURER_ID', {
    get: function () {
      return MOECO_MANUFACTURER_ID;
    }
  });
  Object.defineProperty(package$scan, 'MOECO_SERVICE_ID', {
    get: function () {
      return MOECO_SERVICE_ID;
    }
  });
  Object.defineProperty(package$scan, 'MOECO_CHARACTERISTIC_ID', {
    get: function () {
      return MOECO_CHARACTERISTIC_ID;
    }
  });
  $$importsForInline$$['klock-root-klock-js-legacy'] = $module$klock_root_klock_js_legacy;
  package$scan.MoecoBleScanner = MoecoBleScanner;
  var package$filter = package$scan.filter || (package$scan.filter = {});
  package$filter.ManufacturerIdFilter = ManufacturerIdFilter;
  package$filter.ScanFilter = ScanFilter;
  package$filter.UidFilter = UidFilter;
  var package$di = package$sdk.di || (package$sdk.di = {});
  package$di.MoecoSdk = MoecoSdk;
  var package$location = package$sdk.location || (package$sdk.location = {});
  package$location.LocationProvider = LocationProvider;
  package$location.MoecoLocation = MoecoLocation;
  var package$logger = package$sdk.logger || (package$sdk.logger = {});
  package$logger.Logger = Logger;
  package$logger.LoggerImpl = LoggerImpl;
  Object.defineProperty(LogLevel, 'DEBUG', {
    get: LogLevel$DEBUG_getInstance
  });
  Object.defineProperty(LogLevel, 'INFO', {
    get: LogLevel$INFO_getInstance
  });
  Object.defineProperty(LogLevel, 'ERROR', {
    get: LogLevel$ERROR_getInstance
  });
  package$logger.LogLevel = LogLevel;
  var package$destinations = package$logger.destinations || (package$logger.destinations = {});
  package$destinations.LogDestination = LogDestination;
  Object.defineProperty(GateMetaData, 'Companion', {
    get: GateMetaData$Companion_getInstance
  });
  Object.defineProperty(GateMetaData, '$serializer', {
    get: GateMetaData$$serializer_getInstance
  });
  var package$messages = package$sdk.messages || (package$sdk.messages = {});
  var package$encoder = package$messages.encoder || (package$messages.encoder = {});
  package$encoder.GateMetaData_init_ixgqeb$ = GateMetaData_init;
  package$encoder.GateMetaData_init_lkxan3$ = GateMetaData_init_0;
  package$encoder.GateMetaData = GateMetaData;
  Object.defineProperty(GatewayData, 'Companion', {
    get: GatewayData$Companion_getInstance
  });
  Object.defineProperty(GatewayData, '$serializer', {
    get: GatewayData$$serializer_getInstance
  });
  package$encoder.GatewayData_init_rqxtf3$ = GatewayData_init;
  package$encoder.GatewayData = GatewayData;
  Object.defineProperty(Geolocation, 'Companion', {
    get: Geolocation$Companion_getInstance
  });
  Object.defineProperty(Geolocation, '$serializer', {
    get: Geolocation$$serializer_getInstance
  });
  package$encoder.Geolocation_init_z3xv5n$ = Geolocation_init;
  package$encoder.Geolocation = Geolocation;
  Object.defineProperty(GatewayMessage, 'Companion', {
    get: GatewayMessage$Companion_getInstance
  });
  Object.defineProperty(GatewayMessage, '$serializer', {
    get: GatewayMessage$$serializer_getInstance
  });
  package$encoder.GatewayMessage_init_xs6n7z$ = GatewayMessage_init;
  package$encoder.GatewayMessage = GatewayMessage;
  package$encoder.MoecoMessagesEncoder = MoecoMessagesEncoder;
  $$importsForInline$$['kotlinx-serialization-kotlinx-serialization-core-js-legacy'] = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy;
  package$encoder.MoecoMessagesEncoderImpl = MoecoMessagesEncoderImpl;
  var package$network = package$sdk.network || (package$sdk.network = {});
  package$network.MessagesSender = MessagesSender;
  package$network.Provider = Provider;
  package$network.CommonProvider = CommonProvider;
  package$network.SocketOpener = SocketOpener;
  package$network.Socket = Socket;
  package$network.KtorSocketOpener = KtorSocketOpener;
  package$network.KtorSocket = KtorSocket;
  Object.defineProperty(package$network, 'TAG', {
    get: function () {
      return TAG_0;
    }
  });
  var package$server = package$network.server || (package$network.server = {});
  package$server.ServerInfo = ServerInfo;
  GateMetaData$$serializer.prototype.typeParametersSerializers = GeneratedSerializer.prototype.typeParametersSerializers;
  GatewayData$$serializer.prototype.typeParametersSerializers = GeneratedSerializer.prototype.typeParametersSerializers;
  Geolocation$$serializer.prototype.typeParametersSerializers = GeneratedSerializer.prototype.typeParametersSerializers;
  GatewayMessage$$serializer.prototype.typeParametersSerializers = GeneratedSerializer.prototype.typeParametersSerializers;
  START_COMMAND = toByte_0(0);
  STATUS_EXTENSION = toByte_0(1);
  TAG = 'Bluetooth Connection';
  MOECO_MANUFACTURER_ID = 1970;
  MOECO_SERVICE_ID = 'd0230000-8e41-4474-ad8b-bfb027b20667';
  MOECO_CHARACTERISTIC_ID = 'd0230001-8e41-4474-ad8b-bfb027b20667';
  TAG_0 = 'Moeco Socket';
  Kotlin.defineModule('moecoSdk-sdk', _);
  return _;
}));

//# sourceMappingURL=moecoSdk-sdk.js.map
